import axios from 'axios';
import { LANDING_PAGE, LINK_JITSIMEET, authDomain } from '../../../modules/API/constants_ts';
import { refreshTokenWrapper } from './axiosClient';
import { getConfigAutoGuest, getTokens } from '../base/util/cookies';
// Create an axios instance with default settings
const axiosAuthHeader = axios.create({
    baseURL: authDomain,
    headers: {
        'content-type': 'application/json',
    },
    method: 'GET',
});
// Interceptor for requests to include authorization token
axiosAuthHeader.interceptors.request.use(async (config) => {
    const token = getTokens().accessToken;
    if (token) {
        // config.headers = config.headers;
        config.headers.set('Authorization', `Bearer ${token}`);
        // config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
    }
    else if (location.href === LINK_JITSIMEET || location.href === `${LINK_JITSIMEET}/`) {
        location.href = LANDING_PAGE;
    }
    else {
        // GUEST_JOIN case
        const { iAmRecorder } = APP.store.getState()['features/base/config'];
        const autoGuest = getConfigAutoGuest();
        if (!iAmRecorder || !autoGuest) {
            // TODO
            // APP.store.dispatch(openLoginDialog());
        }
    }
    return config;
});
// Safely parse JSON
function safeParse(str) {
    try {
        return JSON.parse(str);
    }
    catch (e) {
        return str;
    }
}
// Interceptor for handling responses and refreshing token if necessary
axiosAuthHeader.interceptors.response.use((response) => {
    return response.data;
}, async (error) => {
    const originalRequest = error.config;
    if (error?.response?.status === 401 && !originalRequest._retry) {
        try {
            const token = await refreshTokenWrapper();
            originalRequest._retry = true;
            axiosAuthHeader.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            originalRequest.headers['Authorization'] = `Bearer ${token}`;
            if (originalRequest?.data) {
                originalRequest.data = safeParse(originalRequest?.data);
            }
            return axiosAuthHeader(originalRequest);
        }
        catch (e) {
            return Promise.reject(e);
        }
    }
    return Promise.reject(error);
});
export default axiosAuthHeader;
